import Parse from 'html-react-parser';

function BMP20136(props) {
    let svgCode =
    `<svg width="34" height="60" viewBox="0 0 34 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect y="30" width="34" height="30" fill="grey" fill-opacity="0.5"/>
        <path d="M21.5455 35.9091V42.2727H12.4545V35.4545M17.9091 39.5455V35.9091M10.6364 54.0909V47.2727L12 45.9091H22L23.3636 47.2727V54.0909M24.2727 35L7.00002 35L7 55L27 55L27 38.6364L24.2727 35Z" stroke="${props.highlightColour}" stroke-width="2"/>
        <path d="M21.5455 5.90909V12.2727H12.4545V5.45454M17.9091 9.54546V5.90909M10.6364 24.0909V17.2727L12 15.9091H22L23.3636 17.2727V24.0909M24.2727 5L7.00002 5L7 25L27 25L27 8.63636L24.2727 5Z" stroke="${props.highlightColour}" stroke-width="2"/>
    </svg>`

    props.svgReturn(66, svgCode, "bmp00136", 34, 60);

    const style = {
        display: props.display
    }

    return (
        <div style={style}>
            {Parse(svgCode)}
        </div>
    );
}

export default BMP20136;